import React from 'react';
import ReceiptLayout from '../receipt.layout';
import { STORE_LOCATIONS } from '../../../../utils/location/locationHelper';
import IllustrationComponent from '../components/illustration.component';

const NotFoundView = () => {
  const supportUrl =
    window.Jbhifi?.storeLocation === STORE_LOCATIONS.NZ
      ? 'https://support.jbhifi.co.nz/hc/en-nz/requests/new?ticket_form_id=14820252324377'
      : 'https://support.jbhifi.com.au/hc/en-au/requests/new?ticket_form_id=360006301073' ||
        'https://support.jbhifi.com.au/hc/en-au/requests/new?ticket_form_id=360006301073';
  return (
    <ReceiptLayout ripped>
      <div className="no-receipt-container">
        <IllustrationComponent name="notfound" />
        <div className="no-receipt-text-container">
          <h5 className="no-receipt-heading">Sorry there's no receipt here</h5>
          <p className="no-receipt-text">
            We can't find the receipt you're looking for or it may not exist. Double check the link we sent you by SMS.
          </p>
          <p className="no-receipt-text">
            Still no luck?{' '}
            <a href={supportUrl} target="_blank" rel="noreferrer">
              Contact us
            </a>{' '}
            and our team can help you out.
          </p>
        </div>
      </div>
    </ReceiptLayout>
  );
};

export default NotFoundView;
